export default __webpack_public_path__ + "ca921613d2eb2acd7a3e09296d8d592c.jpg";